import { CommonEditContext, CreateCommonSearchContext } from "./common-data.model";

export const DefaultKpiEconomy = {
  search: CreateCommonSearchContext(),
  edit: {
    editForm: {
      model: {} as KpiEconomyEditCriteria,
      dirty: false,
      status: null as any,
      errors: null as any
    },
  } as CommonEditContext<KpiEconomyEditCriteria>,
}

export interface KpiEconomyEditCriteria {
  kpiScore: number;
  kpiValue: number;
}
